import {VariantConfigT} from '@/lib/types/colors.types';

export const greenConfig: VariantConfigT = {
  basic: {
    icon: 'green',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'green',
    active: 'green',
  },
  outline: {
    icon: 'green',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'green',
    iconHover: 'green',
    iconActive: 'green',
    hover: 'green',
    active: 'green',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
